module.exports = __webpack_public_path__ + "static/media/IMG_0595_Reduced.7a373150.jpg";